import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header'
import './index.css'

export default function Documentarios () {
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [nextText, setNextText] = useState('');

  const handleTransition = (route, text) => {
    setNextText(text);
    setIsTransitioning(true);
    setTimeout(() => {
      navigate(route);
    }, 1000);
  };

  const episodios = Array.from({ length: 9 }, (_, i) => i + 1);

  return(
    <div>
      <Header show={false} cor='preto' />
      <div id='documentarios-capa' >
        <div id='overlay-black' >
          <div id='documentarios-titulo'>
            <span className="fade-in-right text-white p-4 rounded-lg">DOCUMENTÁRIOS</span>
            <div id='episodios'>
              <div id='episodios-title' className="fade-in-right text-white p-4 rounded-lg" >EPISÓDIOS</div>
              {episodios.map(numero => (
                <span
                  key={numero}
                  className="episodio-link"
                  onClick={() => handleTransition(`/episodios/${numero}`, `Episódio ${numero}`)}
                  style={{ cursor: 'pointer', color: 'white', padding: '0 8px' }}
                >
                  {numero}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}